import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import ContextMenuOption from './ContextMenuOption';

const styles = theme => ({
  root: {
    width: 330,
    paddingBottom: theme.spacing(1),
    margin: theme.spacing(1, 0),
  },
  nestedRoot: {
    width: 400,
    pointerEvents: 'auto',
    paddingBottom: theme.spacing(1),
    margin: theme.spacing(1, 0),
  },
  menuOption: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  nestedMenu: {
    width: 400,
    pointerEvents: 'none',
  },
});

const ContextMenu = ({
  className, classes, children, config, test,
}) => {
  const [contextMenuParams, setContextMenuParams] = useState(null);

  const handleClose = () => setContextMenuParams(null);

  return (
    <div
      onContextMenu={(event) => {
        if (event.ctrlKey) {
          return;
        }
        event.preventDefault();
        setContextMenuParams(contextMenuParams === null ? {
          top: event.clientY,
          left: event.clientX,
          selection: window.getSelection()?.toString(),
        } : null);
      }}
      className={classNames(className)}
    >
      {children}
      <Menu
        open={!!contextMenuParams}
        anchorReference={'anchorPosition'}
        anchorPosition={{ top: contextMenuParams?.top, left: contextMenuParams?.left }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        onClose={handleClose}
      >
        <div className={classNames(classes.root)} test={test}>
          {config.options.map(option => (
            <ContextMenuOption
              selection={contextMenuParams?.selection}
              classes={classes}
              option={option}
              handleClose={handleClose}
              test={option.test}
            />
          ))}
        </div>
      </Menu>
    </div>
  );
};

ContextMenu.defaultProps = {
  test: null,
};

ContextMenu.propTypes = {
  className: PropTypes.string.isRequired,
  classes: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  config: PropTypes.shape({
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func,
    })),
  }).isRequired,
  test: PropTypes.string,
};

export default withStyles(styles)(ContextMenu);
